import {
    TASK_STATUS_SUCCESS,
    TASK_STATUS_FAIL,
    TASK_STATUS_PENDING
} from "../../actions/types";

const initialState = { 
    taskStatuses: [],
    isTaskStatusLoading: false
    };

const task_statuses_reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case TASK_STATUS_SUCCESS:
            return {
                ...state,
                taskStatuses: payload.taskStatuses,
                isTaskStatusLoading: false
            };
        case TASK_STATUS_PENDING:
            return {
                ...state,
                taskStatuses: payload.taskStatuses,
                isTaskStatusLoading: true
            };
        case TASK_STATUS_FAIL:
            return {
                ...state,
                taskStatuses: [],
                isTaskStatusLoading: false
            };
        default:
            return state;
    }
}
export default task_statuses_reducer